// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10c2e","right":"styles_right__2YKxM"};